import { Avatar, Button, Grid, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import {
  ActionBtnBackground,
  LeftArrowLarge,
  MedsHistory,
  OrderEquipment,
} from 'Images';
import { FC } from 'react';

interface IBtnProps {
  imageSrc: string;
  text: string;
  callback: () => void;
}

export const ButtonAction: FC<IBtnProps> = ({
  imageSrc,
  text,
  callback,
}: IBtnProps) => {
  const isDesktop = useIsDesktop();

  const BtnMobileStyle = {
    maxWidth: '102px',
    height: '100px',
    boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
    borderRadius: '16px',
    background: '#FFFFFF',
    padding: '14px 7px',
    position: 'relative',
  };

  const BtnDesktopStyle = {
    maxWidth: '303px',
    height: '160px',
    boxShadow: '0px 3px 21px rgba(45, 112, 217, 0.15)',
    borderRadius: '16px',
    background: '#FFFFFF',
    backdropFilter: 'blur(16.3097px)',
    padding: '24px',
    cursor: 'pointer',
    position: 'relative',
    overflow: 'hidden',
  };

  return isDesktop ? (
    <Button onClick={callback} color={'inherit'} sx={{ p: '0' }}>
      <Grid container alignContent='space-between' sx={BtnDesktopStyle}>
        <Avatar
          src={ActionBtnBackground}
          alt=''
          sx={{
            width: '100%',
            height: '160px',
            position: 'absolute',
            transform: 'translate(-5px, -31px)',
            zIndex: '-1',
            '@media screen and (max-width: 1010px)': {
              transform: 'translate(-5px, -40px)',
            },
          }}
        />
        <Grid
          item
          container
          spacing={1.5}
          sx={{
            height: '60px',
          }}
        >
          <Grid item xs={3}>
            <Avatar
              src={imageSrc}
              alt=''
              sx={{
                width: 'min(6vw, 64px)',
                height: 'min(6vw, 64px)',
              }}
            />
          </Grid>
          <Grid container item xs={9} md={7} marginTop={2.5}>
            <Typography
              sx={{
                fontSize: '20px',
                lineHeight: '26px',
                fontWeight: '700',
                alignSelf: 'flex-end',
                textAlign: 'left',
                marginLeft:
                  imageSrc === MedsHistory || imageSrc === OrderEquipment
                    ? '7px'
                    : '',
              }}
            >
              {text}
            </Typography>
            {imageSrc === OrderEquipment && (
              <>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </>
            )}
          </Grid>
        </Grid>
        <Grid item container alignItems='flex-end' flexDirection='column'>
          <Avatar
            src={LeftArrowLarge}
            alt=''
            sx={{
              width: '34px',
              height: '15px',
            }}
          />
        </Grid>
      </Grid>
    </Button>
  ) : (
    <Button onClick={callback} sx={BtnMobileStyle} color={'inherit'}>
      <Grid container justifyContent='center'>
        <Avatar
          src={ActionBtnBackground}
          alt={''}
          sx={{
            width: '102px',
            height: '100px',
            position: 'absolute',
            transform: 'translate(0px, -23px)',
            borderRadius: '29px',
          }}
        />
        <Avatar src={imageSrc} alt='' />
        <Typography
          align='center'
          sx={{
            height: '32px',
            fontSize: 'min(3.5vw, 14px)',
            lineHeight: '16px',
            fontWeight: '700',
            zIndex: '1',
          }}
        >
          {text}
        </Typography>
      </Grid>
    </Button>
  );
};
